<template>
  <div id="profile">
    <div class="col_1_2 controls">
      <span class="comm_dropdown" v-if="geotype !== 'county'">Filter to:</span>
      <select class='comm_dropdown'
              v-if="geotype !== 'county'"
              v-on:change="setFilteredCounty($event.target.value)">
        <option disabled value="">Choose a Region to Focus on</option>
        <option
          v-bind:value="null"
          v-bind:selected="!filteredCounty"
        >All Counties Selected
        </option>
        <option
          v-for="id in countyIds"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="filteredCounty===id"
        >{{namesForCountyFilter.get(id)[0]}}
        </option>
      </select>
      <span class="comm_dropdown">Selected {{namesFromGeotype[geotype].singularName}}:</span>
      <select class='comm_dropdown' v-on:change="setSelected(+$event.target.value)">
        <option disabled value="">Choose a Community</option>
        <option
          v-bind:value="8999"
          v-bind:selected="!selectedId"
        >Southeast Michigan
        </option>
        <option
          v-for="id in mcdIds"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="selectedId===id"
        >{{namesForSelectedType.get(id)[0]}}
        </option>
      </select>
      &nbsp;
      <a
        v-if="showCPLink()"
        v-bind:href="CPLink()"
        v-bind:title="'View ' + (selectedName || (filteredCounty && namesForCountyFilter.get(filteredCounty) && namesForCountyFilter.get(filteredCounty)[0]) || 'Southeast Michigan') + ' Community Profile Page' "
        style="white-space: nowrap;"
      ><small>Link to: </small><img style="width: 18px;" src="images/region.svg" alt=""> Community
        Profile
      </a>
      <button type="button" class="share mapboxgl-ctrl-icon" title="Copy URL and Share" v-on:click="shareURL()">Share <font-awesome-icon icon='share-square'/></button>
    </div>
    <div id="charts" ref="charts">
      <div class="non-distribution">
        <h2 class="col_1_2 geoname">{{(selectedName || (filteredCounty && namesForCountyFilter.get(filteredCounty) && namesForCountyFilter.get(filteredCounty)[0]) || 'Southeast Michigan')}}</h2>
        <div style="font-weight: bold;">{{'Total Population: '+ format(totalInd.totalpop_24)}}</div>
        <div style="font-weight: bold;">{{'Median Household Income: $'+ format(totalInd.emedhhinc_24)}}</div>
        <PopPyramidChart
          v-bind:ageDataFemale="ageDataFemale"
          v-bind:ageDataMale="ageDataMale"
          v-bind:getIndName="getIndName"
          v-bind:printing="printing"
        />
        <IndDistributionChart
          v-bind:nameOfChart="'Households by Income'"
          v-bind:indicators="incomeData"
          v-bind:indicatorsCutoffs="incomeChartCutoffs"
          v-bind:getIndName="getIndName"
          v-bind:printing="printing"
        />
      </div>
      <ol class="groupList">
        <li
          v-for="gName in groupNames"
          v-bind:key="gName"
        >
          <a
            v-bind:href="'#group-'+gName"
            v-on:click.prevent.stop="zoomTo('group-'+gName)"
          >
            <font-awesome-icon :icon='groupDesc[gName].iconName'/>
            <span>{{gName}}</span>
          </a>
        </li>
      </ol>
      <div
        class="distribution"
        v-for="gName in groupNames"
        v-bind:key="gName"
        v-bind:id="'group-'+gName"
      >
        <h2 class="col_1_2" v-if="groupDesc[gName]">
          <font-awesome-icon :icon='groupDesc[gName].iconName'/>
          {{groupDesc[gName].longName || (gName + ' Data')}} by {{namesFromGeotype[geotype].singularName}}
          <span class="info"
                v-if="groupDesc[gName].descExtra"
                v-tooltip="{
                        content: groupDesc[gName].descExtra,
                        classes: ['d3-tip'],
                        container: $refs.charts,
                      }"
          ></span>
        </h2>
        <div v-if="groupDesc[gName] && groupDesc[gName].desc" class="col_1_2"
           v-html="groupDesc[gName].desc">
        </div>
        <GioDistributionChart
          v-for="shortcut in groups[gName]"
          v-bind="shortcut"
          v-bind:key="shortcut.name"
          v-bind:geogData="allNormalizedGeogData[shortcut.name]"
          v-bind:isSelectedShortcut="selectedShortcut && shortcut.name === selectedShortcut.name"
          v-bind:colorLegendData="selectedShortcut && shortcut.name === selectedShortcut.name && colorLegendData"
          v-bind:selectedId="selectedId"
          v-bind:hoverId="hoverId"
          v-bind:countyData="countyData"
          v-bind:regionData="regionData"
          hideWhenInvisible="true"
          v-bind:printing="printing"
          v-on:set-map="setMap($event)"
          v-on:set-sel-geom-id="setSelected($event)"
          v-on:set-hov-geom-id="setHover($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GioDistributionChart from './charts/GioDistributionChart.vue'
import IndDistributionChart from './charts/IndDistributionChart.vue'
import PopPyramidChart from './charts/PopPyramidChart.vue'
import * as d3 from 'd3'

export default {
  name: 'Profile',
  components: { PopPyramidChart, GioDistributionChart, IndDistributionChart },
  props: [
    'shortcuts',
    'groupNames',
    'groups',
    'groupDesc',
    'selectedShortcut',
    'colorLegendData',
    'incomeChartIndicators',
    'incomeChartCutoffs',
    'ageDataMaleChartIndicators',
    'ageDataFemaleChartIndicators',
    'selectedId',
    'selectedName',
    'filteredCounty',
    'namesForSelectedType',
    'namesForCountyFilter',
    'hoverId',
    'allGeogData',
    'countyData',
    'regionData',
    'getIndName',
    'getIndYear',
    'getIndMoeName',
    'namesFromGeotype',
    'geotype',
    'inInerMode',
    'printing',
  ],
  methods: {
    setMap: function (id) {
      this.$emit('set-map', id)
    },
    setFilteredCounty: function (id) {
      this.$emit('set-filtered-county', id)
    },
    countyIdLookup: function (id) {
      let ids = {
        93: 'https://data.semcog.org/community-profiles?mcd=7005,7010,7015,7020,7025,7027,7030,7035,7040,7045,7050,7055,7060,7065,7070,7075,7080,7085,7090,7095,7100&counties=93',
        99: 'https://data.semcog.org/community-profiles?mcd=3005,3010,3015,3020,3025,3030,3035,3040,3045,3050,3055,3060,3065,3070,3075,3080,3085,3090,3095,3100,3105,3110,3115,3120,3125,3130,3135&counties=99',
        115: 'https://data.semcog.org/community-profiles?mcd=5005,5010,5015,5020,5025,5030,5035,5040,5045,5047,5050,5055,5060,5065,5070,5075,5080,5085,5090,5095,5100,5105,5110,5115,5120&counties=115',
        125: 'https://data.semcog.org/community-profiles?mcd=2005,2010,2015,2020,2025,2030,2035,2040,2045,2050,2055,2060,2065,2072,2073,2075,2080,2085,2090,2095,2100,2105,2110,2115,2120,2125,2130,2135,2140,2145,2150,2155,2160,2165,2170,2172,2175,2180,2185,2190,2195,2200,2205,2210,2215,2220,2230,2235,2240,2245,2250,2252,2255,2260,2265,2270,2275,2280,2285,2290,2295,2300&counties=125',
        147: 'https://data.semcog.org/community-profiles?mcd=6005,6010,6015,6020,6025,6030,6035,6040,6045,6050,6055,6060,6065,6070,6075,6080,6085,6090,6095,6100,6105,6110,6115,6120,6125,6135,6140,6142,6145,6150,6155,6160,6165&counties=147',
        161: 'https://data.semcog.org/community-profiles?mcd=4005,4010,4015,4018,4020,4025,4030,4035,4040,4045,4050,4055,4060,4065,4070,4075,4080,4085,4090,4095,4100,4105,4110,4115,4120,4125,4130,4135&counties=161',
        163: 'https://data.semcog.org/community-profiles?mcd=5,1005,1010,1015,1020,1025,1030,1040,1045,1050,1055,1060,1065,1070,1075,1080,1085,1090,1095,1100,1105,1110,1115,1120,1125,1130,1135,1140,1145,1150,1155,1160,1165,1170,1175,1180,1185,1190,1200,1205,1210,1215,1220&counties=163',
      }
      return ids[id] || id || 8999
    },
    zoomTo: function (gName) {
      document.getElementById(gName).scrollIntoView()
    },
    setSelected: function (id) {
      this.$emit('set-sel-geom-id', id)
    },
    setHover: function (id) {
      this.$emit('set-hov-geom-id', id)
    },
    CPLink: function () {
      if (this.selectedId && this.geotype !== 'county') {
        return 'https://data.semcog.org/community-profiles?mcd=' + this.selectedId
      } else if (this.selectedId && this.geotype === 'county' ) {
        return this.countyIdLookup(this.selectedId)
      } else if (this.filteredCounty) {
        return this.countyIdLookup(this.filteredCounty)
      } else {
        return 'https://data.semcog.org/community-profiles'
      }
    },
    showCPLink: function () {
      let show = true
      if (this.geotype === 'CensusTract') {
        show = false
      }
      if (this.geotype === 'SchoolDistrict') {
        show = false
      }
      return show
    },
    shareURL: function () {
      let textarea = document.createElement('textarea');
      textarea.textContent = window.location.href;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy')
    },
    format: d3.format(',d'),
  },
  computed: {
    mcdIds: function () {
      return Array.from(this.namesForSelectedType.keys()).sort(
        (aId, bId) => {
          let a = this.namesForSelectedType.get(aId)[0]
          let b = this.namesForSelectedType.get(bId)[0]
          return a.localeCompare(b)
        })
    },
    countyIds: function () {
      return Array.from(this.namesForCountyFilter.keys()).sort(
        (aId, bId) => {
          let a = this.namesForCountyFilter.get(aId)[0]
          let b = this.namesForCountyFilter.get(bId)[0]
          return a.localeCompare(b)
        })
    },
    allNormalizedGeogData: function () {
      let chartData = {}
      this.shortcuts.forEach(i => {
        chartData[i.name] = this.allGeogData
          .filter(val => val[i.denominator])
          .filter(val => val[i.denominator] > (val[this.getIndMoeName(i.denominator)] || 0))
          .filter(val => val[i.numerator])
          .map(val => {
            let denom = val[i.denominator]
            let denomMoe = val[this.getIndMoeName(i.denominator)] || 0
            let noom = val[i.numerator]
            let noomMoe = val[this.getIndMoeName(i.numerator)] || 0
            let value = noom / denom

            // MOE of X/Y =1/Y * SQRT ((XMOE)2- ((X/Y)2*(YMOE)2))
            let a = Math.pow(noomMoe, 2)
            let b = Math.pow(value * denomMoe, 2)
            let moe
            if (a > b && i.properFraction) {
              moe = Math.sqrt(a - b) / denom
            } else {
              moe = Math.sqrt(a + b) / denom
            }

            let maxMoe
            if (i.properFraction) {
              maxMoe = 1
            } else {
              maxMoe = 2 * value
            }

            return {
              name: val.name.trim(),
              geoid: val.geoid,
              value: [
                Math.max(value - moe, 0),
                value,
                Math.min(value + moe, maxMoe),
              ],
            }
          })
      })
      this.shortcuts.forEach(i => chartData[i.name].sort((a, b) => b.value[1] - a.value[1]))

      return chartData
    },
    incomeData: function () {
      return this.incomeChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    ageDataMale: function () {
      return this.ageDataMaleChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    ageDataFemale: function () {
      return this.ageDataFemaleChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    totalInd: function () {
      if (!this.selectedId && !this.regionData) {
        return {}
      }
      let sel = (this.selectedId && this.allGeogData.find(geo => geo.geoid === this.selectedId))
      if (sel) {
        return sel
      }
      if (this.filteredCounty) {
        return this.countyData
      }
      return this.regionData
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #profile {
    grid-column: 2;
    grid-row: 2;
    background: #fefefe;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content auto;
    min-height: 0;
  }

  #charts {
    overflow-y: auto;
    background: #fefefe;
    position: relative;
  }

  #charts > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 5px;
    row-gap: 5px;
    align-items: end;
    margin: 10px;
    padding: 7px;
    border: solid 1px #9E9E9E;
    border-radius: 10px;
  }

  h2, h3, h4, h5 {
    margin: 0;
  }

  div a {
    font-size: medium;
    color: #0f2d53;
    font-weight: bold;
    vertical-align: middle;
  }

  .groupList {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    background: #eef7f5;
    position: sticky;
    top: 0;
    z-index: 1;
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .groupList li {
    display:inline;
  }

  .groupList li a {
    color: #0f2d53;
  }

  .groupList li a span {
    padding-left: 0.5ex;
  }

  .controls {
    z-index: 3;
    padding: 4px;
    background-color: #eef7f5;
  }

  .col_1_2 {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .geoname{
    font-size: 1.9em;
  }

  .share {
    float: right;
    background: rgba(107, 153, 91, 0.7);
    border-radius: 4px;
    border-width: 1px;
    border-color: #9aa5a9;
  }
  .share:active{
      background: #9aa5a9;
  }

  .info {
    content: '';
    cursor: pointer;
    position: absolute;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill='%23333333' fill-rule='evenodd' d='M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0'/%3E %3C/svg%3E");
    background-color: rgba(255, 255, 255, 0.5);
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 12px;
  }

  /deep/ .my-tooltip {
    display: block !important;
    z-index: 1;
    font-size: small;
    max-width: 90%;
  }

  /deep/ .my-tooltip strong {
    font-size: medium;
  }

  /deep/ .my-tooltip small {
    color: #9aa5a9;
    font-size: small;
  }

  /deep/ .my-tooltip .my-tooltip-inner {
    background: #292424;
    color: white;
    opacity: 0.95;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  /deep/ .my-tooltip .my-tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #292424;
    opacity: 0.95;
    z-index: 1;
  }

  /deep/ .my-tooltip[x-placement^="top"] {
    margin-bottom: 10px;
  }

  /deep/ .my-tooltip[x-placement^="top"] .my-tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }

  /deep/ .my-tooltip[x-placement^="bottom"] {
    margin-top: 10px;
  }

  /deep/ .my-tooltip[x-placement^="bottom"] .my-tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }

  /deep/ .my-tooltip[x-placement^="right"] {
    margin-left: 10px;
  }

  /deep/ .my-tooltip[x-placement^="right"] .my-tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  /deep/ .my-tooltip[x-placement^="left"] {
    margin-right: 10px;
  }

  /deep/ .my-tooltip[x-placement^="left"] .my-tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  /deep/ .my-tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: #292424;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
  }

  /deep/ .my-tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
  }

  /deep/ .my-tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  /deep/ .my-tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }

  .single-ind {
    text-align: center;
  }

  .comm_dropdown {
    border-color: #f5f5f5;
    border-radius: 10px;
    max-width: 100%;
    font-size: small;
    margin-left: 3px;
  }

  .comm_dropdown:focus {
    outline: 0;
    border-color: black;
  }

  .comm_dropdown option {
    font-size: 0.8rem;
  }

  /deep/ .mapboxgl-ctrl-group > button {
    width: 29px;
    height: 29px;
  }

  @media (max-width: 576px), print {
    #charts {
      overflow-y: unset;
    }

    #profile {
      grid-column: 1;
      overflow-y: unset;
    }

    .distribution {
      page-break-before: always;
    }

    .groupList li a span {
      display: none;
    }
  }

  @media (max-width: 970px) {
    .comm_dropdown {
      width: 100%;
    }

    .groupList li a span {
      display: block;
    }
  }
</style>
